import classNames from 'classnames';
import { CancelButton } from 'components/common-form/sidePanel/actions/shared/CancelButton';
import { TradeWay } from 'models/TradeWay';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { TradeConfirmButtonProps } from './tradeButtons.confirming.connect';
import { TradeInitButtonProps } from './tradeButtons.initiating.connect';

export function RawInitTradeButtonsComponent({
  canTrade,
  onTrade,
  onCancel,
  id,
  quoteId,
  tradeLabelKey,
  tradeWay,
  e2e,
  children,
}: TradeInitButtonProps) {
  const [hasExecuted, setHasExecuted] = useState(false);
  const onTradeClick = () => {
    setHasExecuted(true);
    onTrade(quoteId);
  };
  const isTradeDisabled = !canTrade || hasExecuted;
  return (
    <div className="d-flex flex-column my-3">
      {children}
      <div className="d-flex">
        <CancelButton context="trade" onCancel={onCancel} className="me-1 w-50 my-1" />
        <button
          className={classNames('btn btn-xl btn-primary btn-block w-50 my-1 ms-1', getTradeWayColor(tradeWay))}
          data-e2e={e2e}
          disabled={isTradeDisabled}
          id={id}
          onClick={onTradeClick}
          type="button"
        >
          <FormattedMessage id={tradeLabelKey} />
        </button>
      </div>
    </div>
  );
}

export function RawConfirmTradeButtonsComponent({
  canTrade,
  onTrade,
  onCancel,
  id,
  quoteId,
  tradeLabelKey,
  e2e,
  children,
  tradeWay,
}: TradeConfirmButtonProps) {
  const [hasExecuted, setHasExecuted] = useState(false);
  const onTradeClick = () => {
    setHasExecuted(true);
    onTrade(quoteId);
  };
  const isTradeDisabled = !canTrade || hasExecuted;
  return (
    <div className="d-flex w-100 flex-wrap mt-1">
      {children}
      <button
        className={classNames('btn btn-xl btn-primary btn-block w-100 mx-1 mb-1 mt-2', getTradeWayColor(tradeWay))}
        data-e2e={e2e}
        disabled={isTradeDisabled}
        id={id}
        onClick={onTradeClick}
        type="button"
      >
        <FormattedMessage id={tradeLabelKey} />
      </button>
      <CancelButton context="trade" onCancel={() => onCancel(quoteId)} className="mx-1 w-100 my-1" />
    </div>
  );
}

function getTradeWayColor(tradeWay: TradeWay): classNames.Argument {
  return {
    ' bg-turquoise-60': tradeWay === 'Sell',
    'bg-pink-60': tradeWay === 'Buy',
  };
}
